import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { SyncErrorRepush, syncErrorRepush } from './syncErrorRepush'
import { SyncErrorTaskInput } from './types'

export const useSyncErrorRepush = ({
  taskId,
  input
}: {
  taskId: string
  input: SyncErrorTaskInput
}): SyncErrorRepush | undefined => {
  const { manualTask } = useManualTask({ taskId })
  const isTaskPending = manualTask?.status === 'PENDING'

  return isTaskPending ? syncErrorRepush(input) : undefined
}
